import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { UserService } from '../../../services/user.service'
import { AdministrationService } from '../../../services/administration.service'
import { MatSnackBar } from '@angular/material';
import { MatSort, MatDialog } from '@angular/material';
import { AddNewUserLevelDialog } from '../../administration/user-level-list/dialog.addnewuserlevel';
import { EditUserLevelDialog } from '../../administration/user-level-list/dialog.edituserlevel';

@Component({
  selector: 'app-user-level-list',
  templateUrl: './user-level-list.component.html',
  styleUrls: ['./user-level-list.component.css']
})
export class UserLevelListComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  errorMessage: string = '';
  loading: boolean = false;
  datasource = [];

  totalCount: number = 0;
  userName: string = '';
  screenCode: string = '';

  constructor(private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private userService: UserService) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.loading = true;
    this.getList();
  }

  addNewUserLevel() {
    let dialogRef = this.dialog.open(AddNewUserLevelDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add successful') {
        this.getList();
        this.openSnackBar('New user level added.', '');
      }
    });
  }

  editUserLevel(d: any) {
    this.loading = true;

    let userLevel = {
      Usr_Level_Id: d.Usr_Level_Id,
      Usr_Level: d.Usr_Level
    }
    let edit_sub = this.administrationService.getUserLevelDetails(userLevel)
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {

          } else if (data.status === 200) {
            let userLevelDetails = data.body['userLevelDetails'];

            if (userLevelDetails) {
              this.openEditUserLevelDialog(d.Usr_Level_Id, d.Usr_Level, userLevelDetails);
            } else {
              this.openSnackBar('User level details is empty.', '');
            }
          } else {
            this.openSnackBar('Get user level details error.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(edit_sub);
  }

  openEditUserLevelDialog(Usr_Level_Id: string, Usr_Level: String, Usr_Level_Details: any) {
    let dialogRef = this.dialog.open(EditUserLevelDialog, {
      width: '60%',
      disableClose: true,
      data: {
        UsrLevelId: Usr_Level_Id,
        UsrLevel: Usr_Level,
        UsrLevelDetails: Usr_Level_Details
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        this.getList();
        this.openSnackBar('Changes saved.', '');
      }
    });
  }

  getList() {
    let init_sub = this.administrationService.getUserLevelList()
      .subscribe(
        (data) => {
          this.loading = false;
          this.datasource = data.body['userLevels'];
          this.totalCount = this.datasource.length;
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
